import Phaser      from 'phaser';
import PauseButton from '../PauseButton/PauseButton';
import { wait }    from '../../tools/functions';

class PauseScene extends Phaser.Scene {
    constructor ( config ) {
        super( config );
        Phaser.Scene.call( this, { key: 'PauseScene' } );
    }

    init () {
        this._isPaused = false;
        this._pauseButton = new PauseButton( this );
    }

    preload () {
        this._pauseButton.preload();
    }

    create () {
        this._pauseButton.create();
        this.input.once( 'pointerdown', () => {
            this.scene.resume( 'MainScene' );
        }, this );
    }

    update ( time, delta ) {
        this._pauseButton.update();
    }

    async togglePause () {
        if ( !this._isPaused ) {
            this._isPaused = true;
            this.scene.pause( 'MainScene' );
            // todo error pause trigger only second time
        } else {
            this._isPaused = false;
            this.scene.resume( 'MainScene' );
        }
        return this._isPaused;
    }


    get isPaused () {
        return this._isPaused;
    }
}

export default PauseScene;
